import { versions } from "./versions";

/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  envName: "dev",
  production: false,
  api_base_url: "https://api.dev.filkhedma.net",
  google_analytics_key: "UA-120632985-2",
  faceBookId: "256226715112676",
  google_gtm_key: "GTM-NQDT44C",
  google_gtm_auth: "FvDfycpXklVAcz7TTKKncA",
  google_gtm_env: "env-6",
  ...versions,
  applyRollbar: false,
  firebase: {
    apiKey: "AIzaSyC2wtHsLnAT0wdudeKMorRrcHrv7qJZrtc",
    authDomain: "develop-customer-website.firebaseapp.com",
    databaseURL: "https://develop-customer-website.firebaseio.com",
    projectId: "develop-customer-website",
    storageBucket: "develop-customer-website.appspot.com",
    messagingSenderId: "308586128074",
    appId: "1:308586128074:web:5ffc8e87848170d3ec4a33",
    measurementId: "G-MGZZRWN1JQ"
  }
};
